// extracted by mini-css-extract-plugin
module.exports = {"education-content":"education_education-content__TYtqu","education-column1":"education_education-column1__O9iWR","education-column2":"education_education-column2__2iEpp"};